import calculateTotalSavings from "./calculate_total_savings";
import getInterestRates from "../../../game-views/objects/get_interest_rates";
import findCurrentSavingsObj from "./find_current_savings_obj";
import initializeSavingsInfoArr from "./initialize_savings_info_arr";
import createCDList from "./create_CD_list";
import calcDepositPercent from "../../xMoneyBuilderObjects/calc_deposit_percent";

export const createSavingsInfoArr = (savingsArr, currentGameDate, savingsClass, currentPriceArr, 
    companyMatchRate, gameNbrMonths, savingInterestRates) => {
    // savingsArr is from the savings db record
    let savingsInfoExists = false;
    let totalSavingsArr = [];
    const savingsInfoArr = initializeSavingsInfoArr(savingsClass);
    let totalSavingsObj = {};
    // savingsInfoArr is the information for the new savingsInfo 
         
    savingsInfoExists = true;
    totalSavingsObj = calculateTotalSavings(savingsArr, gameNbrMonths, savingsClass);
    totalSavingsArr = totalSavingsObj.totalSavingsArr;
 
    let interestRateArr = [];
    if (savingsClass === "bank"){
        interestRateArr = getInterestRates(savingsInfoArr, savingInterestRates);
    }
    let CDList = [];
    const savingsArrObj = savingsArr.find(elem => elem.savingsType === "CD");
    if (savingsArrObj && savingsArrObj.closedDate === ""){ 
        CDList = createCDList(savingsArrObj, currentGameDate);
    }
         
    for (let i=0; i<savingsInfoArr.length; i++){
        const savingsType = savingsInfoArr[i].savingsType;
        let savingsTotalObj = {};
        if (savingsInfoExists){
            findCurrentSavingsObj(savingsInfoArr, i, savingsArr, savingsType, currentGameDate);
            savingsTotalObj = totalSavingsArr.find(elem => elem.savingsType === savingsType);
            if (savingsTotalObj && savingsTotalObj.savingsType){
                savingsInfoArr[i].totalSavingsAmt = savingsTotalObj.totalSavings;
            }
        }

        const totalObj = totalSavingsArr.find(elem => elem.savingsType === savingsType);
        if (totalObj){
            let intEarned = +totalObj.totalInterest;
            intEarned = intEarned.toFixed(2);
            savingsInfoArr[i].intEarned = intEarned.toString();
            savingsInfoArr[i].totalDeposited = +totalObj.totalDeposit;
            savingsInfoArr[i].prevTransferAmt = totalObj.totalTransferAmt;
           //  savingsInfoArr[i].prevTransferFee = totalObj.totalTransferFee;
        }
       
        const svgIndx = savingsInfoArr[i].svgIndx;
        if (svgIndx !== null){
            savingsInfoArr[i].startDate = savingsArr[svgIndx].startDate;
            savingsInfoArr[i].currentMonthlyAmt = savingsArr[svgIndx].monthlyDepositAmt;
            savingsInfoArr[i].monthlyDepositAmt = savingsArr[svgIndx].monthlyDepositAmt;
            if (savingsClass === "bank"){
                savingsInfoArr[i].intRate = savingsArr[svgIndx].interestRate;
            }else{    
                const currentPriceObj = currentPriceArr.find(elem => elem.retirementType === savingsType);
                if (currentPriceObj){
                    savingsInfoArr[i].currentPrice = currentPriceObj.currentPrice;
                }
                savingsInfoArr[i].companyMatchRate = companyMatchRate;
                savingsInfoArr[i].totalMatchAmt = totalObj.totalMatchAmt;
                savingsInfoArr[i].quantity = totalObj.totalShareQty; 
                savingsInfoArr[i].startPrice = savingsArr[svgIndx].startPrice; 
                savingsInfoArr[i].depositPercent = savingsArr[svgIndx].depositPercent;
            }
        }else{
            if (savingsClass === "bank"){
                if (savingsInfoArr[i].intRate === 0){
                    const intRateObj = interestRateArr.find(elem => elem.savingsType === savingsType);
                    savingsInfoArr[i].intRate = (intRateObj.intRate * 100).toFixed(4);
                }
            }else{
                savingsInfoArr[i].companyMatchRate = companyMatchRate;
                const currentPriceObj = currentPriceArr.find(elem => elem.retirementType === savingsType);
                if (currentPriceObj){
                    savingsInfoArr[i].currentPrice = currentPriceObj.currentPrice;
                }
            }
        }
    }
    let returnObj = {};
    if (savingsClass === "retirement"){
        calcDepositPercent(savingsInfoArr);
    }
    if (savingsClass === "bank"){
        returnObj = {savingsInfoArr: savingsInfoArr, interestRateArr: interestRateArr, 
            CDList: CDList, ...totalSavingsObj};
    }else{
        returnObj = {savingsInfoArr: savingsInfoArr, ...totalSavingsObj};
    }
    return returnObj;
}

export default createSavingsInfoArr;